module.exports = __webpack_public_path__ + "static/media/google-play-qr-code.c4eeed7d.svg";